
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'number',
        field: 'ordem',
        label: 'Ordem',
        info:'Esse campo é utilizado para ordenar o GHE',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'text',
        field: 'ghe',
        label: 'GHE',
        maxlength:15,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
        type: 'text',
        field: 'descricao',
        label: 'Descrição',
        maxlength: 150,
        rules: ['required']
    }, 
    {
        class: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Observações',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'descricao_ambiente_trabalho',
        label: 'Descrição do Ambiente de Trabalho',
        info: 'Descrição individual do ambiente de trabalho deste setor, usada no evento S-2240 do eSocial.',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-12',
        type: 'boolean',
        field: 'ordenar',
        label: 'Ordenar as colunas a partir daqui',
        info: 'Habilite essa opção se quiser ordenar as os GHE a partir desse item. Isso funciona caso precisar incluir um GHE entre vários outros.',
        rules: ['']
    }
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/ghe/_form/ltcat-ghe-editar.js